exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.border-style[data-v-582298fa] {\n  border: 4px solid #f7f7fa;\n  padding: 10px;\n}\n", "", {"version":3,"sources":["/home/superaccess/portal-local-2.0/Superaccess2.0/app/javascript/src/components/admin/departments/New.vue"],"names":[],"mappings":";AAAA;EACE,0BAA0B;EAC1B,cAAc;CAAE","file":"New.vue","sourcesContent":[".border-style {\n  border: 4px solid #f7f7fa;\n  padding: 10px; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-582298fa","scoped":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./app/javascript/src/components/admin/departments/New.vue
// module id = 480
// module chunks = 0 1 6 141